if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        if (!activeMediaId) return;
        const container = this.querySelector('[role="document"]') || this;

        // Force ONLY the clicked media to be the active one. The modal renders the
        // variant's featured media first, and it gets re-activated shortly after the
        // dialog opens — which would show the wrong image. `apply` re-asserts the
        // clicked media as active (idempotent), and a short-lived observer keeps it
        // correct until the open settles.
        const apply = () => {
          let active = null;
          container.querySelectorAll(':scope > [data-media-id]').forEach((item) => {
            const isActive = item.getAttribute('data-media-id') === activeMediaId;
            if (item.classList.contains('active') !== isActive) item.classList.toggle('active', isActive);
            // Set display inline — the modal's variant-image CSS keeps the featured
            // image visible and would otherwise override a class-based hide.
            const wanted = isActive ? 'block' : 'none';
            if (item.style.display !== wanted) item.style.display = wanted;
            if (isActive) {
              active = item;
              if (item.tagName === 'IMG' && item.loading === 'lazy') item.loading = 'eager';
              item.querySelectorAll('img[loading="lazy"]').forEach((img) => {
                img.loading = 'eager';
              });
            }
          });
          return active;
        };

        const activeMedia = apply();
        if (!activeMedia) return;

        const scrollToActive = () => activeMedia.scrollIntoView({ block: 'start' });
        scrollToActive();
        requestAnimationFrame(scrollToActive);
        const activeImg = activeMedia.querySelector('img');
        if (activeImg && !activeImg.complete) {
          activeImg.addEventListener('load', scrollToActive, { once: true });
        }

        const observer = new MutationObserver(() => apply());
        observer.observe(container, { subtree: true, attributes: true, attributeFilter: ['class'] });
        setTimeout(() => observer.disconnect(), 2500);

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
